document.addEventListener("DOMContentLoaded", function () {
  (function () {
    /**
     * Functions for audio preview player
     */
    // Preview binding helper (idempotent), supports dynamic elements
    function bindPreview(preview) {
      if (!preview || preview.dataset.previewBound === "1") return;
      const audio = preview.querySelector(".product-detail__preview-player");
      const timeline = preview.querySelector(".product-detail__preview-timeline");
      const toggleButton = preview.querySelector(".product-detail__preview-button");
      const progressPath = preview.querySelector(
        ".product-detail__preview-timeline-path"
      );
      if (!audio || !timeline || !toggleButton || !progressPath) return;

      function resetToggleButton() {
        try { audio.currentTime = 0; } catch (_) {}
        preview.classList.remove("is-playing");
        try {
          progressPath.style.strokeDasharray = "0, 100";
        } catch (_) {
          progressPath.setAttribute("stroke-dasharray", "0, 100");
        }
      }

      function updateDashOffset() {
        const duration = audio.duration || 0;
        const percentage = duration ? (audio.currentTime / duration) * 100 : 0;
        try {
          progressPath.style.strokeDasharray = `${percentage}, 100`;
        } catch (_) {
          progressPath.setAttribute("stroke-dasharray", percentage + ", 100");
        }
      }

      toggleButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (audio.paused) {
          // Stop and reset any other preview instances (audio, icon, timeline)
          document.querySelectorAll(".product-detail__preview").forEach((other) => {
            if (other === preview) return;
            const otherAudio = other.querySelector(".product-detail__preview-player");
            const otherTimeline = other.querySelector(
              ".product-detail__preview-timeline"
            );
            const otherTimelinePath = other.querySelector(
              ".product-detail__preview-timeline-path"
            );

            if (otherAudio) {
              try { otherAudio.pause(); otherAudio.currentTime = 0; } catch (_) {}
            }
            other.classList.remove("is-playing");
            if (otherTimeline && otherTimelinePath) {
              otherTimelinePath.setAttribute("stroke-dasharray", "0, 100");
            }
          });

          audio.play();
          preview.classList.add("is-playing");
        } else {
          audio.pause();
          resetToggleButton();
        }
      });

      audio.addEventListener("ended", resetToggleButton);
      audio.addEventListener("timeupdate", updateDashOffset);
      preview.dataset.previewBound = "1";
    }

    // Initial bind for existing previews
    document
      .querySelectorAll(".product-detail__preview")
      .forEach((node) => bindPreview(node));

    // Observe DOM for dynamically injected previews
    const previewObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes && m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches && node.matches(".product-detail__preview")) {
            bindPreview(node);
          }
          node.querySelectorAll &&
            node
              .querySelectorAll(".product-detail__preview")
              .forEach((n) => bindPreview(n));
        });
      }
    });
    previewObserver.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });

    /**
     * Support chat trigger (Freshdesk widget)
     *
     * Hash routing:
     *   #supportchat            → open widget (defaults)
     *   #supportchat-widerruf   → open widget + preselect ticket type
     *                             + rename submit button
     *
     * Strings come from theme.strings.support (locale files).
     */
    const SUPPORT_VARIANTS = {
      "#supportchat": "default",
      "#supportchat-widerruf": "cancellation",
    };

    const WIDGET_ID = 201000000205;
    const WIDGET_SRC =
      "https://euc-widget.freshworks.com/widgets/" + WIDGET_ID + ".js";
    const WIDGET_SCRIPT_ID = "dynamic-fw-script";

    function getSupportStrings() {
      return (window.theme && theme.strings && theme.strings.support) || {};
    }

    /**
     * Launch the Freshdesk widget by destroying any previous instance and
     * re-injecting the script. This is the only reliable way to reset
     * sticky state (disabled fields, custom labels) per Freshdesk support.
     */
    function launchSupportWidget(applyConfig) {
      // 1. Destroy current instance, if any
      if (typeof window.FreshworksWidget === "function") {
        try { window.FreshworksWidget("destroy"); } catch (_) {}
      }

      // 2. Remove the previous dynamic script tag
      const oldScript = document.getElementById(WIDGET_SCRIPT_ID);
      if (oldScript) oldScript.remove();

      // 3. Reset globals and rebuild the queue stub
      window.fwSettings = { widget_id: WIDGET_ID };
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.FreshworksWidget = queue;

      // 4. Hide the floating launcher, apply variant config, then open
      window.FreshworksWidget("hide", "launcher");
      if (typeof applyConfig === "function") applyConfig();
      window.FreshworksWidget("open");

      // 5. Inject a fresh widget script tag
      const script = document.createElement("script");
      script.id = WIDGET_SCRIPT_ID;
      script.src = WIDGET_SRC;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    function openSupportWidget(variant) {
      const strings = getSupportStrings();
      const isCancellation =
        variant === "cancellation" && strings.cancellation;

      launchSupportWidget(function () {
        if (isCancellation) {
          FreshworksWidget("prefill", "ticketForm", {
            type: strings.cancellation.ticketType,
          });
          FreshworksWidget("disable", "ticketForm", ["type"]);
          FreshworksWidget("setLabels", {
            de: { contact_form: { submit: strings.cancellation.submitButton } },
            en: { contact_form: { submit: strings.cancellation.submitButton } },
          });
        } else if (strings.defaultSubmit) {
          FreshworksWidget("setLabels", {
            de: { contact_form: { submit: strings.defaultSubmit } },
            en: { contact_form: { submit: strings.defaultSubmit } },
          });
        }
      });
    }

    document.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function (event) {
        const variant =
          SUPPORT_VARIANTS[event.currentTarget.hash] ||
          SUPPORT_VARIANTS[event.currentTarget.href];
        if (!variant) return;
        event.preventDefault();
        openSupportWidget(variant);
      });
    });

    const initialVariant = SUPPORT_VARIANTS[window.location.hash];
    if (initialVariant) {
      openSupportWidget(initialVariant);
    }

    /**
     * Intercept the cookie settings link in the footer and open the consent banner.
     * Expects a menu link with URL "#cookie-settings" (footer navigation).
     */
    (function initCookieSettingsLink() {
      const FOOTER_SELECTOR = 'footer, .page-footer, .page-footer__inner';
      const LINK_SELECTOR = 'a[href="#cookie-settings"]';

      function openCookiePreferences() {
        const btn = document.querySelector('.cc-revoke');
        if (btn) {
          try { btn.click(); } catch (_) {}
          return;
        }
        // Fallback: wait briefly until the consent widget initializes
        let tries = 0;
        const t = setInterval(() => {
          const b = document.querySelector('.cc-revoke');
          if (b || tries++ > 20) {
            clearInterval(t);
            if (b) { try { b.click(); } catch (_) {} }
          }
        }, 100);
      }

      // Delegated click (also works for dynamically rendered menus)
      document.addEventListener('click', function (e) {
        const link = e.target.closest(LINK_SELECTOR);
        if (!link) return;
        // Optional: ensure the click happened within the footer
        const inFooter = link.closest(FOOTER_SELECTOR);
        if (!inFooter) return;
        e.preventDefault();
        openCookiePreferences();
      }, { capture: true });

      // Direct access via hash
      if (window.location.hash === '#cookie-settings') {
        setTimeout(openCookiePreferences, 150);
      }
    })();

    /**
     * Functions for sticky buy button
     */
    if (document.querySelector(".product-detail__sticky-wrapper")) {
      const stickyWrapper = document.querySelector(
        ".product-detail__sticky-wrapper"
      );

      function handleStickyBuyButton() {
        const targetElement = document.querySelector(
          ".section-product-template"
        );

        const rect = targetElement.getBoundingClientRect();
        const screenHeight = window.innerHeight;

        if (rect.top < screenHeight / 2 && rect.bottom >= screenHeight / 2) {
          stickyWrapper.classList.remove(
            "product-detail__sticky-wrapper--hidden"
          );
        } else {
          stickyWrapper.classList.add("product-detail__sticky-wrapper--hidden");
        }
      }

      window.addEventListener("scroll", handleStickyBuyButton);

      handleStickyBuyButton();
    }

    /**
     * Function to remove giftcards from menu for Austria
     */
    fetch("https://galakto.com/browsing_context_suggestions.json")
      .then((res) => res.json())
      .then((r) =>
        $("body").addClass(
          "country_" + r.detected_values.country.handle.toLowerCase()
        )
      )
      .then(function () {
        if ($("body").hasClass("country_at")) {
          $(".site-nav__item__gutscheine").remove();
          if (
            window.location.pathname == "/products/galakto-geschenkgutschein"
          ) {
            window.location.href = "https://galako.com";
          }
        }
      });

    /**
     * Function to read URL parameters
     */
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    // var testParam = getUrlParameter('test');
    // if (testParam === 'true') {
    //   const soldOutWrapper = document.querySelector(".product-detail__sold-out-wrapper");
    //   soldOutWrapper.classList.add("product-detail__sold-out-wrapper--visible");
    // }

    /**
     * Function for Add-To-Cart buttons in product-block sections
     */

    const addToCartForms = document.querySelectorAll(
      ".product-block__add-to-cart"
    );

    addToCartForms.forEach((form) => {
      theme.initAjaxAddToCartForm($("form.ajax-product-form", form));
    });

    /**
     * Function for the "Add to clipboard" buttons in product-block sections
     */
    const copyToClipboardButtons = document.querySelectorAll(
      ".product-block__copy-to-clipboard"
    );

    copyToClipboardButtons.forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        const identifierValue = button.getAttribute("data-value");
        navigator.clipboard.writeText(identifierValue).then(() => {
          // Hide copy icon
          const copyIcon = button.querySelector(".product-block__copy-icon");
          const copiedIcon = button.querySelector(
            ".product-block__copied-icon"
          );
          if (copyIcon) {
            copyIcon.style.opacity = "0";
          }
          if (copiedIcon) {
            copiedIcon.style.opacity = "1";
          }

          // Reset after 2 seconds
          setTimeout(() => {
            if (copyIcon) {
              copyIcon.style.opacity = "";
            }
            if (copiedIcon) {
              copiedIcon.style.opacity = "";
            }
          }, 2000);
        });
      });
    });

    /**
     * Function for the favorite buttons in product-block sections
     * Uses localStorage to persist favorites across sessions
     * and syncs the UI state based on stored favorites.
     */
    const FAVORITES_KEY = "galakto_favorites";
    function getFavorites() {
      try {
        return JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
      } catch {
        return [];
      }
    }
    function setFavorites(list) {
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(list));
    }
    function syncFavoriteButtons(root = document) {
      const favs = new Set(getFavorites().map(String));
      root.querySelectorAll(".product-block__favorite ").forEach((btn) => {
        const id = String(btn.getAttribute("data-product-id"));
        const active = favs.has(id);
        btn.classList.toggle("product-block__favorite--active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }
    // Initial sync
    syncFavoriteButtons();

    // Event delegation for dynamic content
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".product-block__favorite ");
      if (!btn) return;
      e.preventDefault();
      const id = String(btn.getAttribute("data-product-id"));
      const favs = new Set(getFavorites().map(String));
      const willBeActive = !favs.has(id);
      if (willBeActive) favs.add(id);
      else favs.delete(id);
      setFavorites(Array.from(favs));
      btn.classList.toggle("product-block__favorite--active", willBeActive);
      btn.setAttribute("aria-pressed", willBeActive ? "true" : "false");
    });

    /**
     * Function for the print buttons in product-catalog sections
     */
    const printButtons = document.querySelectorAll(
      ".product-catalog__print-btn"
    );

    printButtons.forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        // All catalog images (your log showed some with hasSrc true but without srcset)
        const images = document.querySelectorAll(
          ".product-catalog__list img.rimage__image"
        );

        function buildSrcsetFromPattern(img) {
          try {
            const widthsRaw = img.getAttribute("data-widths");
            if (!widthsRaw) return null;
            // data-widths is usually a JSON array string
            let widths = [];
            if (widthsRaw.startsWith("[")) {
              widths = JSON.parse(widthsRaw);
            } else {
              widths = widthsRaw
                .split(",")
                .map((w) => parseInt(w.trim(), 10))
                .filter(Boolean);
            }
            const pattern = img.getAttribute("data-src");
            if (!pattern || pattern.indexOf("{width}") === -1) return null;
            const srcset = widths
              .map((w) => pattern.replace("{width}", w) + " " + w + "w")
              .join(", ");
            return { srcset, widths };
          } catch (e) {
            console.warn("[PRINT] buildSrcset Fehler", e);
            return null;
          }
        }

        // Phase 1: Ensure all lazy variants are activated
        images.forEach((img, idx) => {
          const hasSrcset = !!img.getAttribute("srcset");
          const dataSrcset = img.getAttribute("data-srcset");
          const dataSrc = img.getAttribute("data-src");

          if (!hasSrcset) {
            if (dataSrcset) {
              // Simply apply it
              img.setAttribute("srcset", dataSrcset);
            } else if (dataSrc && dataSrc.indexOf("{width}") !== -1) {
              const built = buildSrcsetFromPattern(img);
              if (built) {
                img.setAttribute("srcset", built.srcset);
                // Fallback: set src to the middle width
                const mid = built.widths[Math.floor(built.widths.length / 2)];
                if (!img.getAttribute("src")) {
                  img.setAttribute("src", dataSrc.replace("{width}", mid));
                }
              }
            }
          }

          // Set sizes
          if (!img.getAttribute("sizes")) {
            const dataSizes = img.getAttribute("data-sizes");
            if (dataSizes && dataSizes !== "auto") {
              img.setAttribute("sizes", dataSizes);
            } else {
              // Conservative fallback
              img.setAttribute("sizes", "25vw");
            }
          }
        });

        // Phase 2: Wait for loading/decoding
        const imagePromises = Array.from(images).map((img, idx) => {
          const idInfo = `[IMG ${idx}]`;
          return new Promise((resolve) => {
            // Already fully resolved?
            if (img.complete && img.naturalWidth > 0) {
              resolve();
              return;
            }
            const onLoad = () => {
              resolve();
            };
            const onErr = () => {
              console.warn(idInfo, "error event – weiter");
              resolve();
            };
            img.addEventListener("load", onLoad, { once: true });
            img.addEventListener("error", onErr, { once: true });
            // Try decode() for safety
            if (typeof img.decode === "function") {
              img
                .decode()
                .then(resolve)
                .catch(() => {
                  // decode failed -> keep waiting for load/error
                });
            }
          });
        });

        const startedAt = performance.now();

        const timeoutPromise = new Promise((resolve) => {
          setTimeout(() => {
            resolve("timeout");
          }, 10000);
        });

        Promise.race([
          Promise.all(imagePromises).then(() => "images"),
          timeoutPromise,
        ]).then((result) => {
          // Optional: tiny delay to let layout stabilize
          setTimeout(() => {
            window.print();
          }, 100);
        });
      });
    });
  })();

  /**
   * Vendor filter extension for collection pages
   *
   * Shopify returns at most 100 vendors in the faceted filter.
   * This script reads all vendors from the Storefront API cache
   * (localStorage, populated by bundler-utils.js) and injects
   * missing vendor checkboxes into the Shopify filter.
   *
   * Re-injection happens after every filter update via the "filters-applied" event.
   */
  (function initVendorFilterExtension() {
    const CACHE_KEY = "galakto_product_metafields";
    const CACHE_TIME_KEY = "galakto_product_metafields_time";
    const CACHE_DURATION_MS = 60 * 60 * 1000; // 60 Minuten
    const STOREFRONT_ACCESS_TOKEN = "d18ade8c758f29069b77e54a05ccc338";
    const SHOPIFY_DOMAIN = "1160c4.myshopify.com";

    /**
     * Extract collection handle from the URL
     * @returns {string|null} e.g. "musik" from "/collections/musik"
     */
    function getCollectionHandle() {
      const match = window.location.pathname.match(/^\/collections\/([^/?]+)/);
      return match ? match[1] : null;
    }

    /**
     * Read product metafields from cache
     * @returns {Object|null} All products, or null if cache is missing/expired
     */
    function getProductsFromCache() {
      try {
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);
        const cachedData = localStorage.getItem(CACHE_KEY);

        if (cachedTime && cachedData && cachedData !== "{}") {
          const timeDiff = Date.now() - parseInt(cachedTime);
          if (timeDiff < CACHE_DURATION_MS) {
            return JSON.parse(cachedData);
          }
        }
      } catch (e) {
        console.warn("[VENDOR-FILTER] Cache-Lesefehler:", e);
      }
      return null;
    }

    /**
     * Extract vendors with counts from product data, filtered by collection
     * @param {Object} products - All products from cache/API
     * @param {string} collectionHandle - Handle of the current collection
     * @returns {Map<string, number>} Vendor → count, sorted
     */
    function getVendorsByCollection(products, collectionHandle) {
      const vendors = new Map();
      Object.values(products).forEach((p) => {
        if (!p.vendor) return;
        if (!Array.isArray(p.collections) || !p.collections.includes(collectionHandle)) return;
        vendors.set(p.vendor, (vendors.get(p.vendor) || 0) + 1);
      });
      return new Map(
        Array.from(vendors.entries()).sort(([a], [b]) =>
          a.localeCompare(b, "de")
        )
      );
    }

    /**
     * Load products via Storefront API (fallback when no cache is available)
     * @returns {Object|null} All products
     */
    async function fetchAllProducts() {
      const query = `
        query GetVendors($first: Int!, $after: String) {
          products(first: $first, after: $after) {
            pageInfo { hasNextPage endCursor }
            edges { node { handle title productType vendor
              collections(first: 20) { edges { node { handle } } }
              mfAlter: metafield(namespace: "custom", key: "altersempfehlung") { value }
              mfHoer: metafield(namespace: "custom", key: "hoerrichtung") { value }
            }}
          }
        }
      `;

      const allProducts = {};
      let hasNextPage = true;
      let cursor = null;

      try {
        while (hasNextPage) {
          const response = await fetch(
            `https://${SHOPIFY_DOMAIN}/api/2025-07/graphql.json`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
              },
              body: JSON.stringify({
                query,
                variables: { first: 250, after: cursor },
              }),
            }
          );

          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const data = await response.json();
          if (data.errors)
            throw new Error(JSON.stringify(data.errors));

          const edges = data?.data?.products?.edges ?? [];
          edges.forEach(({ node }) => {
            allProducts[node.handle] = {
              id: node.id,
              handle: node.handle,
              title: node.title,
              productType: node.productType,
              vendor: node.vendor,
              collections: (node.collections?.edges ?? []).map(e => e.node.handle),
              altersempfehlung: node.mfAlter?.value ?? null,
              hoerrichtung: node.mfHoer?.value ?? null,
            };
          });

          hasNextPage = data.data.products.pageInfo.hasNextPage;
          cursor = data.data.products.pageInfo.endCursor;
        }

        // Populate cache (also used by bundler-utils.js)
        localStorage.setItem(CACHE_KEY, JSON.stringify(allProducts));
        localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());

        return allProducts;
      } catch (e) {
        console.error("[VENDOR-FILTER] API-Fehler:", e);
        return null;
      }
    }

    /**
     * Find the vendor filter in the DOM (by the name attribute of its checkboxes)
     */
    function findVendorFilter() {
      const filters = document.querySelectorAll(
        ".cc-filter[data-type='list']"
      );
      for (const filter of filters) {
        const checkbox = filter.querySelector(
          'input[type="checkbox"][name*="filter.p.vendor"]'
        );
        if (checkbox) return { filter, paramName: checkbox.name };
      }
      return null;
    }

    /**
     * Inject missing vendors into the filter
     * @param {Map<string, number>} vendorCounts - Vendor → product count
     */
    function injectMissingVendors(vendorCounts) {
      const vendorFilter = findVendorFilter();
      if (!vendorFilter) return;

      const { filter, paramName } = vendorFilter;
      const list = filter.querySelector(".cc-filter__content ul");
      if (!list) return;

      // Read existing vendor values
      const existingValues = new Set();
      list
        .querySelectorAll('input[type="checkbox"]')
        .forEach((input) => existingValues.add(input.value));

      // Determine missing vendors
      const missingVendors = Array.from(vendorCounts.entries()).filter(
        ([vendor]) => !existingValues.has(vendor)
      );
      if (missingVendors.length === 0) return;

      // Find highest existing index for unique IDs
      let maxIndex = 0;
      list.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        const match = input.id.match(/-(\d+)$/);
        if (match) maxIndex = Math.max(maxIndex, parseInt(match[1]));
      });

      // Derive filter label from existing input (for ID prefix)
      const existingInput = list.querySelector('input[type="checkbox"]');
      const idPrefix = existingInput
        ? existingInput.id.replace(/-\d+$/, "")
        : "cc-filter-Vendor";

      // Create missing checkboxes
      missingVendors.forEach(([vendor, count]) => {
        maxIndex++;
        const id = `${idPrefix}-${maxIndex}`;
        const li = document.createElement("li");
        li.innerHTML = `
          <input type="checkbox" class="checkbox" id="${id}"
                 name="${paramName}" value="${vendor}">
          <label for="${id}">
            <span class="cc-filter-label">${vendor}</span>
            <span>${count}</span>
          </label>
        `;
        list.appendChild(li);
      });

      // Sort alphabetically
      const items = Array.from(list.children);
      items.sort((a, b) => {
        const labelA =
          a.querySelector(".cc-filter-label")?.textContent?.trim() || "";
        const labelB =
          b.querySelector(".cc-filter-label")?.textContent?.trim() || "";
        return labelA.localeCompare(labelB, "de");
      });
      items.forEach((item) => list.appendChild(item));

      console.log(
        `[VENDOR-FILTER] ${missingVendors.length} Vendors ergänzt (gesamt: ${vendorCounts.size})`
      );
    }

    /**
     * Main function: load and inject vendors
     */
    let productsCache = null;

    async function extendVendorFilter() {
      const collectionHandle = getCollectionHandle();
      if (!collectionHandle) return;
      if (!document.querySelector(".cc-facet-filters")) return;
      if (!findVendorFilter()) return;

      if (!productsCache) {
        productsCache = getProductsFromCache();
        if (!productsCache) {
          productsCache = await fetchAllProducts();
        }
      }

      if (productsCache) {
        const vendorCounts = getVendorsByCollection(productsCache, collectionHandle);
        if (vendorCounts.size > 0) {
          injectMissingVendors(vendorCounts);
        }
      }
    }

    // Run on initial page load
    extendVendorFilter();

    // Re-inject after each filter update
    document.addEventListener("filters-applied", () => {
      extendVendorFilter();
    });
  })();
});
